import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';


const routes: Routes = [
  {
    path:'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path:'guide',
    loadChildren: () => import('./features/guide/guide.module').then(m => m.GuideModule),
  },
  {
    path:'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard]
  },
  {
    path:'invoices',
    loadChildren: () => import('./features/invoices/invoices.module').then(m => m.InvoicesModule),
    canActivate: [authGuard]
  },
  {
    path:'user',
    loadChildren: () => import('./features/user/user.module').then(m => m.UserModule),
    canActivate: [authGuard]
  },
  {
    path:'service',
    loadChildren: () => import('./features/service/service.module').then(m => m.ServiceModule),
    canActivate: [authGuard]
  },
  {
    path:'price',
    loadChildren: () => import('./features/price/price.module').then(m => m.PriceModule),
    canActivate: [authGuard]
  },
  {
    path:'project',
    loadChildren: ()=> import('./features/project/project.module').then(m => m.ProjectModule),
    canActivate: [authGuard]
  } ,
  {
    path: 'profile',
    loadChildren: ()=> import('./features/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [authGuard]
  },
  {
    path: 'sign-offer',
    loadChildren: ()=> import('./features/sign-offer/sign-offer.module').then(m => m.SignOfferModule),
  },
  {
    path: 'primer',
    loadChildren: ()=> import('./features/primer/primer.module').then(m => m.PrimerModule),
    canActivate: [authGuard]
  },
  {
    path: 'draft',
    loadChildren: ()=> import('./features/checkout/checkout.module').then(m => m.CheckoutModule),
    canActivate: [authGuard]
  },
  {
    path: 'contact',
    loadChildren: () => import('./features/contact/contact.module').then(m => m.ContactModule),
    canActivate: [authGuard]
  },
  {
    path: 'contract',
    loadChildren: ()=> import('./features/contract/contract.module').then(m => m.ContractModule),
    canActivate: [authGuard]
  },
  {
    path: 'wallet',
    loadChildren: ()=> import('./features/wallet/wallet.module').then(m => m.WalletModule),
    canActivate: [authGuard]
  },
  {
    path: 'discount', 
    loadChildren: () => 
      import ('./features/discount/discount.module').then(m => m.DiscountModule),
    canActivate: [authGuard]
  },
  {
    path:'',
    redirectTo:'dashboard',
    pathMatch: 'full'
  },
  { path: 'products', loadChildren: () => import('./features/products/products.module').then(m => m.ProductsModule) },
  {
    path: '**',
    redirectTo: 'dashboard',
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { 
}
